@if ((useLazyLoad && !isLoaded) || arguments?.length > 0) {
  <sd-arguments-slider
    [data]="arguments"
    [layout]="layout"
    [twicPicsAutoSize]="!isFirst"
    [context]="context"
    [brand]="brandCorner"
    [activeBrand]="activeBrand"
    [isLoading]="useLazyLoad && !isLoaded"
    (clicked)="onClicked($event)"
  />
}
